// extracted by mini-css-extract-plugin
export var buttonsWrapper = "ModalFooter-module--buttonsWrapper--ca3ea";
export var fadeInAnimation = "ModalFooter-module--fadeInAnimation--533aa";
export var modalFooter = "ModalFooter-module--modalFooter--71cb7";